import {
  PATIENTS_BYUSER_GET_LIST,
  PATIENTS_BYUSER_GET_LIST_ERROR,
  PATIENTS_BYUSER_GET_LIST_SUCCESS,
  PATIENTS_BYDOCTOR_GET_LIST,
  PATIENTS_BYDOCTOR_GET_LIST_ERROR,
  PATIENTS_BYDOCTOR_GET_LIST_SUCCESS,
  PATIENT_ADD_ITEM,
  PATIENT_ADD_ITEM_ERROR,
  PATIENT_ADD_ITEM_SUCCESS,
  PATIENT_EDIT_ITEM,
  PATIENT_EDIT_ITEM_ERROR,
  PATIENT_EDIT_ITEM_SUCCESS,
  PATIENT_GET_INFO,
  PATIENT_GET_INFO_ERROR,
  PATIENT_GET_INFO_SUCCESS,
  PATIENT_REMOVE_ITEM,
  PATIENT_REMOVE_ITEM_ERROR,
  PATIENT_REMOVE_ITEM_SUCCESS,
  PATIENTS_CLEAR_DATA,
  PATIENT_CLEAR_DATA,
} from "../actions";

//* GET LIST OF THE PATIENTS PER USER //--------------------------------------------------------
export const getPatientsByUserList = (payload) => {
  return {
    type: PATIENTS_BYUSER_GET_LIST,
    payload: payload,
  };
};

export const getPatientsByUserListSuccess = (items) => {
  return { type: PATIENTS_BYUSER_GET_LIST_SUCCESS, payload: items };
};

export const getPatientsByUserListError = (error) => ({
  type: PATIENTS_BYUSER_GET_LIST_ERROR,
  payload: error,
});

//* GET LIST OF THE PATIENTS PER DOCTOR //--------------------------------------------------------
export const getPatientsByDoctorList = (payload) => {
  //console.log(payload);

  return {
    type: PATIENTS_BYDOCTOR_GET_LIST,
    payload: payload,
  };
};

export const getPatientsByDoctorListSuccess = (items) => {
  // console.log(items);
  return { type: PATIENTS_BYDOCTOR_GET_LIST_SUCCESS, payload: items };
};

export const getPatientsByDoctorListError = (error) => ({
  type: PATIENTS_BYDOCTOR_GET_LIST_ERROR,
  payload: error,
});

//* GET INFO OF THE PATIENT //----------------------------------------------------------
export const getPatientInfo = (payload) => {
  //console.log(payload);

  return {
    type: PATIENT_GET_INFO,
    payload: payload,
  };
};

export const getPatientInfoSuccess = (items) => {
  //console.log(items);
  return { type: PATIENT_GET_INFO_SUCCESS, payload: items };
};

export const getPatientInfoError = (error) => ({
  type: PATIENT_GET_INFO_ERROR,
  payload: error,
});

//* ADD PATIENT // ----------------------------------------------------------------------------------------------
export const addPatientItem = (item) => ({
  type: PATIENT_ADD_ITEM,
  payload: item,
});

export const addPatientItemSuccess = (items) => {
  //console.log(items);

  return {
    type: PATIENT_ADD_ITEM_SUCCESS,
    payload: items,
  };
};

export const addPatientItemError = (error, item) => {
  console.log(error, item);
  return {
    type: PATIENT_ADD_ITEM_ERROR,
    payload: { error, item },
  };
};

//* EDIT PATIENT // ---------------------------------------------------------------------------------------------
export const editPatientItem = (item) => ({
  type: PATIENT_EDIT_ITEM,
  payload: item,
});

export const editPatientItemSuccess = (items) => {
  //console.log(items);

  return {
    type: PATIENT_EDIT_ITEM_SUCCESS,
    payload: items,
  };
};

export const editPatientItemError = (error) => {
  //console.log(error);
  return {
    type: PATIENT_EDIT_ITEM_ERROR,
    payload: error,
  };
};

//* REMOVE PATIENT // ---------------------------------------------------------------------------------------------
export const removePatientItem = (item) => ({
  type: PATIENT_REMOVE_ITEM,
  payload: item,
});

export const removePatientItemSuccess = (items) => {
  // console.log("removePatientItemSuccess", items);

  return {
    type: PATIENT_REMOVE_ITEM_SUCCESS,
    payload: items,
  };
};

export const removePatientItemError = (error) => {
  console.log(error);
  return {
    type: PATIENT_REMOVE_ITEM_ERROR,
    payload: error,
  };
};

//* CLEAR PATIENTS DATA // ---------------------------------------------------------------------------------------------
// clearing redux state when unmounting patient profile page
export const clearPatientsData = (history) => {
  console.log("clearPatientsData -> history", history);

  return {
    type: PATIENTS_CLEAR_DATA,
    payload: { history },
  };
};

//* CLEAR PATIENT DATA // ---------------------------------------------------------------------------------------------
// clearing redux state when unmounting patient profile page
export const clearPatientData = (history) => {
  console.log("clearPatientData -> history", history);

  return {
    type: PATIENT_CLEAR_DATA,
    payload: { history },
  };
};
